/**
 * AdultSettings - Skunked & Stripped (Adult Brand) UI System
 * Encapsulates the 24 strip & adult challenges, row updates,
 * toggles, and timed challenge modal timer controller.
 */

export const ADULT_OPTIONS_LIST = Object.freeze([
  // Group 1: Strip Themed (2 spaces each by default = 12 spaces)
  { key: 'loseClothing', chkId: 'optLoseClothing', countId: 'optLoseClothingCount', pegsId: 'optLoseClothingPegs', prefix: 'optLoseClothing', name: 'You Lose Clothing', actionText: 'Player loses an article of clothing', group: 'strip', icon: '👙', color: '#f43f5e', defaultHoles: [10, 70, 10, 70], timed: false },
  { key: 'gainClothing', chkId: 'optGainClothing', countId: 'optGainClothingCount', pegsId: 'optGainClothingPegs', prefix: 'optGainClothing', name: 'You Gain Clothing', actionText: 'Player gains an article of clothing back', group: 'strip', icon: '🧥', color: '#10b981', defaultHoles: [20, 80, 20, 80], timed: false },
  { key: 'pickWhoLosesClothing', chkId: 'optPickWhoLosesClothing', countId: 'optPickWhoLosesClothingCount', pegsId: 'optPickWhoLosesClothingPegs', prefix: 'optPickWhoLosesClothing', name: 'Pick Who Strips', actionText: 'Player picks who loses an article of clothing', group: 'strip', icon: '🎯', color: '#ec4899', defaultHoles: [30, 90, 30, 90], timed: false },
  { key: 'rightLosesClothing', chkId: 'optRightLosesClothing', countId: 'optRightLosesClothingCount', pegsId: 'optRightLosesClothingPegs', prefix: 'optRightLosesClothing', name: 'Right Neighbor Strips', actionText: 'Person to right loses an article of clothing', group: 'strip', icon: '👉', color: '#3b82f6', defaultHoles: [40, 100, 40, 100], timed: false },
  { key: 'leftLosesClothing', chkId: 'optLeftLosesClothing', countId: 'optLeftLosesClothingCount', pegsId: 'optLeftLosesClothingPegs', prefix: 'optLeftLosesClothing', name: 'Left Neighbor Strips', actionText: 'Person to left loses an article of clothing', group: 'strip', icon: '👈', color: '#8b5cf6', defaultHoles: [50, 110, 50, 110], timed: false },
  { key: 'removeClothingChoice', chkId: 'optRemoveClothingChoice', countId: 'optRemoveClothingChoiceCount', pegsId: 'optRemoveClothingChoicePegs', prefix: 'optRemoveClothingChoice', name: 'Remove Clothing Choice', actionText: 'Remove an article of clothing off person of your choice', group: 'strip', icon: '✂️', color: '#e11d48', defaultHoles: [60, 120, 60, 120], timed: false },

  // Group 2: Adult Themed (Timed Challenges - 1 space each by default = 12 spaces)
  { key: 'touchBreast', chkId: 'optTouchBreast', countId: 'optTouchBreastCount', pegsId: 'optTouchBreastPegs', prefix: 'optTouchBreast', name: 'Touch Breast', actionText: 'Touch breast', group: 'adult', icon: '💋', color: '#f43f5e', defaultHoles: [5, 45, 75, 105], timed: true },
  { key: 'lickBreast', chkId: 'optLickBreast', countId: 'optLickBreastCount', pegsId: 'optLickBreastPegs', prefix: 'optLickBreast', name: 'Lick Breast', actionText: 'Lick breast', group: 'adult', icon: '👅', color: '#ec4899', defaultHoles: [15, 50, 80, 110], timed: true },
  { key: 'suckBreast', chkId: 'optSuckBreast', countId: 'optSuckBreastCount', pegsId: 'optSuckBreastPegs', prefix: 'optSuckBreast', name: 'Suck Breast', actionText: 'Suck breast', group: 'adult', icon: '👄', color: '#d946ef', defaultHoles: [25, 55, 85, 115], timed: true },
  { key: 'touchGenitals', chkId: 'optTouchGenitals', countId: 'optTouchGenitalsCount', pegsId: 'optTouchGenitalsPegs', prefix: 'optTouchGenitals', name: 'Touch Genitals', actionText: 'Touch genitals', group: 'adult', icon: '✨', color: '#a855f7', defaultHoles: [35, 40, 70, 100], timed: true },
  { key: 'lickGenitals', chkId: 'optLickGenitals', countId: 'optLickGenitalsCount', pegsId: 'optLickGenitalsPegs', prefix: 'optLickGenitals', name: 'Lick Genitals', actionText: 'Lick genitals', group: 'adult', icon: '👅', color: '#f43f5e', defaultHoles: [45, 60, 90, 120], timed: true },
  { key: 'suckGenitals', chkId: 'optSuckGenitals', countId: 'optSuckGenitalsCount', pegsId: 'optSuckGenitalsPegs', prefix: 'optSuckGenitals', name: 'Suck Genitals', actionText: 'Suck genitals', group: 'adult', icon: '👄', color: '#ec4899', defaultHoles: [55, 65, 95, 115], timed: true },
  { key: 'fingerGenitals', chkId: 'optFingerGenitals', countId: 'optFingerGenitalsCount', pegsId: 'optFingerGenitalsPegs', prefix: 'optFingerGenitals', name: 'Finger Genitals', actionText: 'Finger genitals', group: 'adult', icon: '👉', color: '#f59e0b', defaultHoles: [65, 45, 75, 105], timed: true },
  { key: 'genitalIntercourse', chkId: 'optGenitalIntercourse', countId: 'optGenitalIntercourseCount', pegsId: 'optGenitalIntercoursePegs', prefix: 'optGenitalIntercourse', name: 'Genital Intercourse', actionText: 'Genital intercourse', group: 'adult', icon: '🔥', color: '#ef4444', defaultHoles: [75, 55, 85, 115], timed: true },
  { key: 'touchAnus', chkId: 'optTouchAnus', countId: 'optTouchAnusCount', pegsId: 'optTouchAnusPegs', prefix: 'optTouchAnus', name: 'Touch Anus', actionText: 'Touch anus', group: 'adult', icon: '🍑', color: '#8b5cf6', defaultHoles: [85, 50, 80, 110], timed: true },
  { key: 'lickAnus', chkId: 'optLickAnus', countId: 'optLickAnusCount', pegsId: 'optLickAnusPegs', prefix: 'optLickAnus', name: 'Lick Anus', actionText: 'Lick anus', group: 'adult', icon: '👅', color: '#ec4899', defaultHoles: [95, 55, 85, 115], timed: true },
  { key: 'fingerAnus', chkId: 'optFingerAnus', countId: 'optFingerAnusCount', pegsId: 'optFingerAnusPegs', prefix: 'optFingerAnus', name: 'Finger Anus', actionText: 'Finger anus', group: 'adult', icon: '👉', color: '#f59e0b', defaultHoles: [105, 60, 90, 120], timed: true },
  { key: 'analIntercourse', chkId: 'optAnalIntercourse', countId: 'optAnalIntercourseCount', pegsId: 'optAnalIntercoursePegs', prefix: 'optAnalIntercourse', name: 'Anal Intercourse', actionText: 'Anal intercourse', group: 'adult', icon: '🔥', color: '#ef4444', defaultHoles: [115, 65, 95, 115], timed: true }
]);

export class AdultSettings {
  static getOptionsList() {
    return ADULT_OPTIONS_LIST;
  }

  static getDefaultSettings() {
    const cfg = {
      target: 121,
      goal: 'high',
      theme: 'passion'
    };
    ADULT_OPTIONS_LIST.forEach(opt => {
      const isStrip = opt.group === 'strip';
      const defaultCount = isStrip ? 2 : 1;
      cfg[opt.chkId] = true;
      cfg[opt.key + 'Count'] = defaultCount;
      cfg[opt.key + 'Pegs'] = 1;
      cfg[opt.key + 'Holes'] = [...opt.defaultHoles];
    });
    return cfg;
  }

  static getOptionDef(key) {
    return ADULT_OPTIONS_LIST.find(o => o.key === key) || null;
  }

  static toggleOptionConfig(optKey, checked, skipSave = false, options = {}) {
    if (typeof document !== 'undefined') {
      const panel = document.getElementById(optKey + 'Config');
      if (panel) panel.style.display = checked ? 'flex' : 'none';
    }
    AdultSettings.updateOptionRows(optKey, skipSave, options);
    for (let i = 1; i <= 4; i++) {
      AdultSettings.onOptionFieldChange(optKey, i, true, options);
    }
    if (checked) {
      if (typeof options.enforceClashNoOverlap === 'function') options.enforceClashNoOverlap();
    } else {
      if (typeof options.updateAllClashDropdowns === 'function') options.updateAllClashDropdowns();
    }
    if (!skipSave && typeof options.saveSettings === 'function') {
      options.saveSettings();
    }
  }

  static updateOptionRows(optKey, skipSave = false, options = {}) {
    const def = AdultSettings.getOptionDef(optKey);
    if (!def) return;
    if (typeof document !== 'undefined') {
      const countEl = document.getElementById(def.countId);
      const count = countEl ? parseInt(countEl.value, 10) : (def.group === 'strip' ? 2 : 1);
      for (let i = 1; i <= 4; i++) {
        const row = document.getElementById(optKey + 'Row' + i);
        if (row) row.style.display = i <= count ? 'flex' : 'none';
      }
    }
    if (typeof options.enforceClashNoOverlap === 'function') options.enforceClashNoOverlap();
    if (!skipSave && typeof options.saveSettings === 'function') {
      options.saveSettings();
    }
  }

  static onOptionPegsChange(optKey, options = {}) {
    const def = AdultSettings.getOptionDef(optKey);
    if (!def) return;
    let pegs = 1;
    if (typeof document !== 'undefined') {
      const pegsEl = document.getElementById(def.pegsId);
      pegs = pegsEl ? parseInt(pegsEl.value, 10) : 1;
      const sub = document.getElementById(optKey + 'Sub');
      if (sub) {
        const pegStr = pegs === 1 ? '1 peg' : `${pegs} pegs`;
        sub.textContent = `${pegStr} · ${def.actionText}`;
      }
    }
    if (options.settings) {
      options.settings[optKey + 'Pegs'] = pegs;
    }
    for (let i = 1; i <= 4; i++) {
      AdultSettings.onOptionFieldChange(optKey, i, true, options);
    }
    if (typeof options.enforceClashNoOverlap === 'function') options.enforceClashNoOverlap();
    if (typeof options.syncAllClashPlacementButtons === 'function') options.syncAllClashPlacementButtons();
    if (typeof options.saveSettings === 'function') {
      options.saveSettings();
    }
  }

  static onOptionFieldChange(optKey, idx, skipSave = false, options = {}) {
    const def = AdultSettings.getOptionDef(optKey);
    if (!def) return;
    const selectId = `${def.prefix}${idx}Hole`;
    if (typeof options.enforceClashNoOverlap === 'function') options.enforceClashNoOverlap(selectId);

    if (typeof document !== 'undefined') {
      const hEl = document.getElementById(selectId);
      const bEl = document.getElementById(`${optKey}Badge${idx}`);
      const pegsEl = document.getElementById(def.pegsId);
      const pegs = parseInt(pegsEl?.value || (options.settings && options.settings[optKey + 'Pegs']) || 1, 10);
      if (hEl && bEl) {
        const h = parseInt(hEl.value, 10) || def.defaultHoles[idx - 1] || 15;
        const streetName = typeof options.getStreetOrTurnName === 'function' ? options.getStreetOrTurnName(h) : '';
        if (pegs > 1) {
          const endH = Math.min(121, h + pegs - 1);
          bEl.textContent = `${streetName ? streetName + ' · ' : ''}Holes ${h}–${endH} (${pegs} Pegs)`;
        } else {
          bEl.textContent = `${streetName ? streetName + ' · ' : ''}Hole ${h}`;
        }
      }
    }

    if (!skipSave && typeof options.saveSettings === 'function') {
      options.saveSettings();
    }
  }

  static getOptionConfigs(optKey, settings = {}) {
    const def = AdultSettings.getOptionDef(optKey);
    if (!def || !settings[def.chkId]) return [];
    const count = Math.min(4, Math.max(1, settings[optKey + 'Count'] != null ? parseInt(settings[optKey + 'Count'], 10) : (def.group === 'strip' ? 2 : 1)));
    const pegs = Math.min(5, Math.max(1, parseInt(settings[optKey + 'Pegs'], 10) || 1));
    const holes = settings[optKey + 'Holes'] || def.defaultHoles;
    const list = [];
    for (let i = 0; i < count; i++) {
      const h = holes[i] != null ? holes[i] : def.defaultHoles[i];
      list.push({
        id: i + 1,
        hole: h,
        start: h,
        end: h + pegs - 1,
        pegs: pegs,
        type: optKey,
        label: `${def.name} ${i + 1}`,
        item: def
      });
    }
    return list;
  }

  static uncheckAll() {
    if (typeof document === 'undefined') return;
    ADULT_OPTIONS_LIST.forEach(opt => {
      const chk = document.getElementById(opt.chkId);
      if (chk) chk.checked = false;
      const panel = document.getElementById(opt.key + 'Config');
      if (panel) panel.style.display = 'none';
    });
  }
}
